import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const profileOtherApiService = createApi({
  reducerPath: "profileOtherApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createProfileOther: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `profiledetail/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getProfileOtherDetails: builder.mutation({
      query: ({ name, params }) => {
        let query = queryParams(params);
        return {
          url: `profiledetail/dropdown/${name}${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useCreateProfileOtherMutation,
  useGetProfileOtherDetailsMutation,
} = profileOtherApiService;
